import { render, staticRenderFns } from "./CurLocation.vue?vue&type=template&id=cd4225d0&scoped=true"
import script from "./CurLocation.vue?vue&type=script&lang=js"
export * from "./CurLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4225d0",
  null
  
)

export default component.exports